import * as Sentry from '@sentry/nextjs';
import { isbot } from 'isbot';

import { publicConfig } from '@public-config';

import { ApiService } from 'services/ApiService';
import { state as currentUserState } from 'state/current-user';

const SentryService = {
    // Accepts unknown because JS can throw anything; react-error-boundary widened its
    // onError signature to match, so callers no longer hand us a guaranteed Error.
    reportError: (error: unknown) => {
        if (typeof window === 'undefined') {
            return;
        }

        const { userAgent } = navigator;

        if (isbot(userAgent)) {
            return;
        }

        const userEmail = currentUserState.user?.email;
        const url = window.location.href;

        const normalized = error instanceof Error ? error : new Error(String(error));

        Sentry.captureException(normalized, {
            tags: { area: 'error-screen' },
            user: userEmail ? { email: userEmail } : undefined,
            extra: { url, userAgent },
        });

        ApiService.post(`${publicConfig.urls.api}/report-error`, {
            errorMessage: normalized.message,
            stack: normalized.stack,
            url,
            userEmail,
            metadata: { userAgent },
        });
    },
};

export { SentryService };
